import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import App from "./App.vue";
import router from "./router";
import BootstrapVue3 from "bootstrap-vue-3";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "aos/dist/aos.css";

import "./assets/custom.scss";

const app = createApp(App);
const head = createHead();

app.use(BootstrapVue3).use(router).use(head).mount("#app");
